import React from 'react';
import forms from '../../data/forms';

const GoNationForms = () => {
  return (
    <div className="form-grid">
      {forms.map(form => (
        <div>
          <a href={form.url} target="_blank" rel="noopener noreferrer" className="card">
            <div className="card-image">
              <img src={form.image} alt={form.title} />
            </div>
            <div className="card-body">
              <h4 className="title">{form.title}</h4>
              <p>{form.excerpt}</p>
              <div>
                <span className="department-pill">{form.department}</span>
              </div>
            </div>
          </a>
        </div>
      ))}
    </div>
  );
};

export default GoNationForms;



// WEBPACK FOOTER //
// ./src/components/GoNationForms/GoNationForms.js